import React from "react";
import Mailto from "react-mailto";
import Link from "gatsby-link";

import "./training.css";
import { rhythm } from "../utils/typography";

// eslint-disable-next-line react/prop-types
export default function Index({ data }) {
	const { email } = data.site.siteMetadata;

	return (
		<main className="container container-page training">
			<h1 style={{ marginBottom: rhythm(1) }}>Training Workshops</h1>

			<p style={{ marginBottom: rhythm(2) }}>
				Please <Mailto email={email}>get in touch</Mailto> to book the following
				in-person training workshops for your organisation.
			</p>

			<h2 style={{ marginBottom: rhythm(0.5) }}>
				<Link to="/training/full-stack-serverless-graphql-appsync">
					Building Full Stack Serverless GraphQL Apps on AWS Appsync
				</Link>
			</h2>
			<p>
				In this course you will learn the best way to build and deploy a
				production grade app that uses a GraphQL API built on Appsync. In the
				process, you will be guided through best practices for building your API
				using AWS{"'"}s integrated services for data storage, authentication and
				receiving real time updates.
			</p>

			<h2 style={{ marginBottom: rhythm(0.5) }}>
				<Link to="/training/introduction-to-serverless-on-aws">
					Introduction to Serverless on AWS Lambda
				</Link>
			</h2>
			<p>
				The workshop is designed for those beginning serverless. It is hands on,
				practical focused. Partipants are guided through the process of building
				and deploying a serverless API backed by a multi-region database using
				DynamoDB, AWS Lambda, API Gateway and Route53.
			</p>
		</main>
	);
}

export const trainingQuery = graphql`
	query TrainingQuery {
		site {
			siteMetadata {
				email
			}
		}
	}
`;



// WEBPACK FOOTER //
// ./src/pages/training.js